<template>
  <v-app>
    <v-card class="bgs rounded-0 d-flex justify-center" flat width="100%" height="100%">
      <v-container>
        <h2 class="text-center mt-6 font24 mb-4">
          {{ $t("Taoify用户注册协议") }}
        </h2>
        <p class="content mt-4">
          {{ $t("提示：您如需注册或使用 Taoify 平台服务，应当完整阅读并严格遵守《Taoify 用户注册协议》，重点关注免责声明、责任限制、违规处置等内容，明确自身权利、义务、使用规则及违约责任。平台后续上线的全部新功能、新工具，均受本使用协议约束。") }}
        </p>
        <p class="content">
          {{ $t("Taoify有权不定期更新、修改本使用协议里的内容，有权在 Taoify网站上发布更新和修改更新本使用协议。最新版本将统一公示于商城处，请您定期查阅条款更新内容。若您不认可条款修订内容，须立即停止使用平台全部服务。") }}
        </p>
        <p class="content">
          {{ $t("本协议为《Taoify 服务条款》补充文件，全套文件还包括《Taoify 用户隐私政策》等，其中《Taoify 服务条款》为主协议。本协议约定内容如与《Taoify 服务条款》冲突，以《Taoify 服务条款》为准；针对主协议未予以明确的事项，适用本协议约定。") }}
        </p>
        <p class="content">
          {{ $t("除本协议明确约定内容以外，双方所有其他权利义务、规则约束均以《Taoify 服务条款》《Taoify 用户使用协议》《Taoify消费协议》等为准。") }}
        </p>
        <p class="content">
          {{ $t("完成账户注册，即代表您已充分知晓并自愿接受Taoify 平台所有协议、条款，包括本协议、《Taoify 用户使用协议》《Taoify 服务条款》《Taoify用户隐私政策》《Taoify 消费协议》等。若您不认可Taoify 平台所有协议、条款内容，请立即停止注册。") }}
        </p>

        <h3 class="titlee">{{ $t("定义") }}</h3>
        <ul>
          <li>{{ $t("1、本协议通用术语定义均与《Taoify 服务条款》保持一致，不再重复释义，仅针对一件代发、店铺代运营、商品存储作出专项释义。") }}</li>
          <li>{{ $t("2、一件代发服务：指经您书面申请，Taoify平台审批通过，您办理完毕一件代发所需手续（包括但不限于签订协议等）后，Taoify平台为您采购中国境内一个或多个商品并在打包完成后寄送到您的指定收货地址的整个服务流程。") }}</li>
          <li>{{ $t("3、店铺代运营服务：指经您书面申请，Taoify平台审批通过，您办理完毕店铺代运营服务所需手续（包括但不限于签订店铺代运营合同/SOP）后，基于您选择的店铺服务项对您的店铺进行代运营操作的整个过程。") }}</li>
          <li>{{ $t("4、商品存储服务：指经您书面申请，Taoify平台审批通过，您办理完毕商品存储开通所需手续（包括但不限于您与平台另行签署协议）后，寄送至Taoify仓库的商品提供存储服务。") }}</li>
        </ul>

        <h3 class="titlee">{{ $t("二、服务内容") }}</h3>
        <p class="content">
          {{ $t("（一）基础服务") }}
        </p>
        <ul>
          <li>{{ $t("1、建店/关联店铺，支持绑定Shopify/Taoify店铺平台。Taoify为您一键创建独立站店铺，同时Taoify能支持绑定您的独立站店铺并提供选择商品、订单管理、包裹管理和国际物流等全流程电商服务。") }}</li>
          <li>{{ $t("2、Taoify为每位用户提供一定的免费次数，您需为超出的次数付费。包括对接的第三方平台，商品搜索/编辑、订单同步到Taoify全球寄送等基础服务。") }}</li>
          <li>{{ $t("3、海量商品搜索、上架，支持中国电商平台(淘宝、天猫、1688)。") }}</li>
        </ul>
        <p class="content">
          {{ $t("（二）增值服务") }}
        </p>
        <ul>
          <li>{{ $t("1、商品采购、仓储打包、国际物流发货过程中发生的商品、包裹等增值服务，包括但不限于到付件代付、修剪线头、商品盘点、商品个性化贴标、EPE泡沫填充物、纸护角卡条、拉伸膜、木架加固等。") }}</li>
          <li>{{ $t("2、店铺运营中增值服务，包括但不限于Taoify为您提供多样化的店铺装修、商品管理、订单管理、店铺搭建托管、产品托管、订单托管、店铺运营托管等。") }}</li>
          <li>{{ $t("3、商品存储。经您书面申请、Taoify 平台审批通过，并另行签署相关协议办妥全部入库手续后，您寄送至 Taoify 仓库的商品方可入库存储。仓储完整收费标准、入库规则、库存管理、催告处置、损毁责任、付费仓储细则等全部权利义务，以双方另行签署的相关协议约定为准。商品自仓库签收当日起享有30天免费存储周期；免费存储到期前3日，平台将通过站内信、绑定邮箱向您发送到期提醒，您可选择将商品出库寄送，或选购付费仓储套餐延长存储期限。若免费存储期限届满后，您未在3日内完成商品出库、亦未办理付费仓储延期，且经平台再次催告后仍未处置滞留商品的，平台有权按照另行签订的协议约定对超期商品统一销毁处理；商品一经销毁无法找回、补发，因逾期未处置产生的全部损失、清运处置费用均由您自行承担，Taoify不承担任何赔偿责任。") }}</li>
        </ul>

        <h3 class="titlee">{{ $t("三、注意事项") }}</h3>
        <ul>
          <li>{{ $t("1、为了您的账号安全，在使用账号服务时，请您事先自行核实操作规则或谨慎决定是否授权给代运营团队操作。") }}</li>
          <li>{{ $t("2、您用户账户的使用记录和交易数据等均以我们的系统记录为准，如您对该等数据存有异议的，可及时向我们提出，我们会根据您提供的相关证据积极予以核实。") }}</li>
          <li>{{ $t("3、平台可选择以网站公告、电子邮件、站内信等方式向您发送通知。") }}</li>
          <li>{{ $t("4、为了保护您及他人的合法权益，如您被他人投诉或投诉他人，我们可能会将您的姓名及身份信息和联系方式，企业经营范围和投诉相关内容等提供给第三方，以便及时解决投诉纠纷。") }}</li>
          <li>{{ $t("5、Taoify销售的商品均采购自中华人民共和国，符合中华人民共和国有关商品质量、安全、卫生、环保、标识等标准，可能与您所在国家的标准存在差异或冲突，您须自行辨别并承担相关风险，Taoify平台不承担任何赔偿责任。") }}</li>
          <li>{{ $t("6、Taoify销售的商品主要符合中华人民共和国的相关知识产权，但因知识产权的地域性因素影响，可能会侵犯您所在国家的相关知识产权，您须自行辨别并承担相关风险，Taoify平台不承担任何赔偿责任。") }}</li>
          <li>{{ $t("7、如果任何组织或个人认为Taoify网站上的任何内容可能侵犯其知识产权，可以通过在线客服及时通知我们，我们会在收到通知后核实。") }}</li>
        </ul>

        <h3 class="titlee">{{ $t("四、其他") }}</h3>
        <p class="content">
          {{ $t("1、平台有关条款（包括但不限于本注册协议等）可能会有除中文以外的其他版本。如果不同语言版本的注册协议之间存在任何差异、不一致或歧义，均以中文文本为准，其他文本仅作参考，不得用于抵触或变更中文文本的含义。本注册协议条款的订立、效力、解释、履行及争议解决，均以中华人民共和国法律作为准据法，排除境外法律冲突规则。《联合国国际货物销售合同公约》不应用于本注册协议，予以明确排除。") }}
        </p>
        <p class="content">
          {{ $t("2、因本协议引起或与本协议有关的任何争议，双方应友好协商解决；协商不成的，任何一方均有权向Taoify 平台经营地有管辖权的人民法院提起诉讼。") }}
        </p>
        <p class="content">
          {{ $t("3、争议处理期间，除争议事项外，双方应继续履行本协议其他约定。") }}
        </p>
        <p class="content">
          {{ $t("4、本协议部分条款被废止、无效或不能执行，并不影响其他条款效力。") }}
        </p>

        <p class="content">
          © Taoify 2024
        </p>
      </v-container>
    </v-card>
  </v-app>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.titlee {
  font-size: 18px;
  font-weight: 600;
  color: #333;
  line-height: 25px;
  margin-top: 25px;
  margin-bottom: 10px;
}
.content {
  font-size: 16px;
  line-height: 30px;
  font-weight: 300;
  color: #6a6e79;
}
li {
  font-size: 16px;
  line-height: 30px;
  font-weight: 300;
  color: #6a6e79;
  margin-left: 20px;
  list-style: initial;
}
</style>
